import { render, staticRenderFns } from "./Frisco.vue?vue&type=template&id=7b86e2a4&lang=pug&"
import script from "./Frisco.vue?vue&type=script&lang=ts&"
export * from "./Frisco.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports